
$(document).ready(function () {

    let number;
    $(".qtyBox .minus").click(function(){
        number = parseInt($(this).siblings(".qtyNo").text());
        if(number > 1){
        number -= 1;
        }
        $(this).siblings(".qtyNo").text(number);
    });
    $(".qtyBox .plus").click(function(){
        number = parseInt($(this).siblings(".qtyNo").text())+1;
        $(this).siblings(".qtyNo").text(number);
    });


    function addItemToCart(variant_id, number) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: number,
                id: variant_id,
            },
            dataType: 'json',
            success: function (data) {
                console.log(data.id);
                window.location = '/cart';
            },
        });
    }
    
    let qty = 1;
    $(".addProductToCartAJAX").click(function(){
        let variant_id = $(this).attr('id');
        qty =  $(this).parent("div").siblings(".qtyBox").children('.qtyNo').text();
        addItemToCart(variant_id, qty);
    });

    // subscribe and save box
    // $(".collection-template-v2 .save-box").change(function(){
    //     if($(this).is(":checked")){
    //         console.log("checked");
    //         $(this).parents(".shopify-product-form").find(".collection-rc-selling-plan-select").click();
    //     }else{
    //         $(this).parents(".shopify-product-form").find("#purchaseTypeOneTime").click();
    //     }
    // });
    // $(".collection-template-v2 .save-box").change();
    $(".collection-columns .add_to_cart").click(function(e){
        e.preventDefault();
        let subs_status = $(".collection-template-v2 .save-box").is(":checked");
        let selling_plan = null;
        let variant_id = $(this).attr('product-id');

        if(subs_status){
            selling_plan = $(this).parents(".shopify-product-form").find(".save-box").data("selling-plan");
        }else{
            selling_plan = "";
        }

        console.log("Variant:", variant_id);
        console.log("Selling Plan:", selling_plan);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: variant_id,
                selling_plan
            },
            dataType: 'json',
            success: function (data) {
                console.log(data.id);
                window.location = '/cart';
            },
        });

    });

    $(document).mouseup(function(e) {
        var container = $(".collection-filters-enabled .custom-filters .faceted-filter-group");
        if (!container.is(e.target) && container.has(e.target).length === 0){
            $(".collection-filters-enabled .custom-filters .faceted-filter-group").removeAttr('open');
        }
    });

    // // tucker product ATC
    // $(".atc-button-pt-product").click(function(e){
    //     e.preventDefault();
    //     let variant_id = $(this).attr('product-id');
    //     // let selling_plan = $(this).attr('selling-plan');
    //     let selling_plan = "";
    //     if($("#BT5 .PDSN .rtx-subscription .rtx-subscription-label").find("#purchaseTypeSubscription").is(":checked")){
    //         selling_plan = $("#BT5 .PDSN .rtx-subscription .rtx-subscription-dropdown").val();
    //     }else{
    //         selling_plan = "";
    //     }       
    //     $.ajax({
    //         type: 'POST',
    //         url: '/cart/add.js',
    //         data: {
    //             quantity: 1,
    //             id: variant_id,
    //             selling_plan: selling_plan
    //         },
    //         dataType: 'json',
    //         success: function (data) {
    //             console.log(data.id);
    //             window.location = '/cart';
    //         },
    //     });
    // });
    // tucker product ATC
    $(".atc-button-pt-product").click(function(e){
        e.preventDefault();
        const variant_id = $(this).attr("product-id");
        let selling_plan = "";

        const widget = document.querySelector("recharge-subscription-widget");
        if (!widget || !widget.shadowRoot) return;

        const widgetSR = widget.shadowRoot;

        // Check if subscription is selected
        const subscriptionOption = widgetSR.querySelector(
            ".rc-purchase-option__subscription input[type='radio']"
        );

        if (subscriptionOption?.checked) {
            const sellingPlans = widgetSR.querySelector("rc-selling-plans");
            if (!sellingPlans || !sellingPlans.shadowRoot) return;

            const selectEl = sellingPlans.shadowRoot.querySelector(
            ".rc-plans-dropdown__select"
            );

            selling_plan = selectEl?.value || "";
        }

        console.log("Variant:", variant_id);
        console.log("Selling Plan:", selling_plan);
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: variant_id,
                selling_plan: selling_plan
            },
            dataType: 'json',
            success: function (data) {
                console.log(data.id);
                window.location = '/cart';
            },
        });
    });

    $("#BT5 .PDSN .collapse-rows .collapse-row .collapse-header, #BT5.crdpsb .collapse-rows .collapse-row .collapse-header").click(function(){
        $(this).siblings(".collapse-body").slideToggle();
        $(this).find(".collapse-arrow").toggleClass("collapse-arrow--open");
    });

    // new home page
    $(".EDC .arrow-icon-left").click(function () { 
        var leftPos = $('.EDC #scrollable-row').scrollLeft();
        $(".EDC #scrollable-row").animate({scrollLeft: leftPos - 250}, 800);
    });
    
    $(".EDC .arrow-icon-right").click(function () { 
        var leftPos = $('.EDC #scrollable-row').scrollLeft();
        $(".EDC #scrollable-row").animate({scrollLeft: leftPos + 250}, 800);
    });

    // add product using AJAX
    $("#BT5 .PGS .add-product-with-ajax").click(function(e){
        e.preventDefault();
        let variant_id = $(this).attr('variant-id');
        addItemToCart(variant_id, 1);
    });


    // KingKomb PDP
    $("#BT5 .KKPDP .add-to-cart-ajax-script").click(function (e) {
        e.preventDefault();
        let variant_id = $(this).parents(".btn-wraper").siblings(".product-variants-wrap").find('.variant-input-script:checked').attr('product-variant-id');
        addItemToCart(variant_id, 1);
    });

    $("#BT5 .KKPDP .product-variants-wrap .variant-input-script").on('change', function (e) {
        e.preventDefault();
        let productPrice = 0;
        let productCatPrice = 0;
        if ($(this).is(":checked")) {
            productPrice = $(this).attr('product-variant-price');
            productCatPrice = $(this).attr('product-variant-cap-price');
            productVariantDescription = $(this).attr('product-variant-description');
            console.log(productPrice, productCatPrice);
            $("#BT5 .KKPDP .product-price").text(productPrice);
            $("#BT5 .KKPDP .product-cat-price").text(productCatPrice);
            $("#BT5 .KKPDP .variant-meta-description").text(productVariantDescription);
            
            
            let savings = parseFloat(productCatPrice) - parseFloat(productPrice);
            let discountPercentage = Math.round((savings / productCatPrice) * 100);
            $("#BT5 .KKPDP .save-amount-block").text(`${discountPercentage}% OFF - YOU SAVE $${savings.toFixed(2)}`);
        }
    });
    $("#BT5 .KKPDP .product-variants-wrap .variant-input-script.first-input").change();

  
    $("#BT5 .KSS .videos-slider .slide-column .video-slide-bottom .control-buttons .play-button").on("click", function () {
        $(this).parents(".video-slide-bottom").siblings(".video-styles")[0].play();
        $(this).hide();
        $(this).siblings(".pause-button").show();
    });
    $("#BT5 .KSS .videos-slider .slide-column .video-slide-bottom .control-buttons .pause-button").on("click", function () {
        $(this).parents(".video-slide-bottom").siblings(".video-styles")[0].pause();
        $(this).hide();
        $(this).siblings(".play-button").show();
    });
    $("#BT5 .KSS .videos-slider .slide-column .video-slide-bottom .mute-buttons .mute-button").on("click", function () {
        $(this).parents(".video-slide-bottom").siblings(".video-styles")[0].muted = true;
        $(this).hide();
        $(this).siblings(".unmute-button").show();
    });
    $("#BT5 .KSS .videos-slider .slide-column .video-slide-bottom .mute-buttons .unmute-button").on("click", function () {
        $(this).parents(".video-slide-bottom").siblings(".video-styles")[0].muted = false;
        $(this).hide();
        $(this).siblings(".mute-button").show();
    });


    // New Master Template
    $(".add-simple-product-to-cart").click(function (e) {
        e.preventDefault();


        let variant_id = null;
        let selling_plan = "";


        // if$(this) has .variable-product class assigned
        if ($(this).hasClass('variable-product')) {
            variant_id = $(".buy-box-simple-product .product-variant-block .product-variant-block-inner.active").attr("variant-id");
            console.log(variant_id);
        }else{
            variant_id = $(this).attr('product-id');
        }


        if($("#BT5 .buy-box-simple-product.subscription .rc-option--subscription .rc-label").find(".rc-radio").is(":checked")){
            selling_plan = $("#BT5 .buy-box-simple-product.subscription .rc-option--subscription .rc-selling-plan-select").val();
        }else{
            selling_plan = "";
        }       
        console.log(selling_plan, variant_id);
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: variant_id,
                selling_plan
            },
            dataType: 'json',
            success: function (data) {
                console.log(data.id);
                window.location = '/cart';
            },
        });
    });

    $(".buy-box-simple-product .product-variant-block .product-variant-block-inner").click(function (e) {
        e.preventDefault();
        $(".buy-box-simple-product .product-variant-block .product-variant-block-inner").removeClass("active");
        $(this).addClass("active");

        let variantPrice = $(this).attr("variant-price");
        let variantSalePrice = $(this).attr("variant-sale-price");

        console.log(variantPrice, variantSalePrice);

        $(this).parents(".buy-box-simple-product").find(".price-styles").find(".original-price").text(variantPrice);
        $(this).parents(".buy-box-simple-product").find(".price-styles").find(".sale-price").text(variantSalePrice);

        let variantImage = $(this).attr("variant-image");
        $(this).parents(".buy-box-simple-product").find(".product-image").attr('src', variantImage);
    })
    $(".buy-box-simple-product .product-variant-block .product-variant-block-inner").first().click();


    $("#BT5 .buy-box-simple-product.subscription .rtx-subscription .rtx-subscription-dropdown").change(function (e) {
        let subscriptionValue = $(this).val();
        
        let subscriptionText = $(this).find(`option[value=${subscriptionValue}]`).text();
        console.log(subscriptionValue, subscriptionText);

        $(this).parents(".rtx-subscription").find(".select-subscription-frequency").text(subscriptionText);
    });
    $("#BT5 .buy-box-simple-product.subscription .rtx-subscription .rtx-subscription-dropdown").change();

    $(".buy-box-simple-product .rc-widget-container .rc-radio").change(function (e) {
        let parentEle = $(this).parents(".rc-option");
        $(".buy-box-simple-product .rc-widget-container .rc-option").removeClass("rc-option--active");
        if($(this).is(":checked")){
            $(parentEle).addClass("rc-option--active");
        }else{
            $(parentEle).removeClass("rc-option--active");
        }
    });
});